export const conflictFieldNames = {
    fullRecordWithoutRestrictedData: "Full record without restricted data",
    importMethod: "Import method",
    studyType: "Study type",
    accessData: "Access data",
    projectType: "Project type",
    title: "Study title",
    briefSummary: "Brief summary",
    description: "Detailed description",
    clinicalTrialPhase: "Study phase",
    primaryDiseaseOrConditions: "Disease(s) or condition(s) being studied",
    interventions: "Intervention(s)",
    outcomes: "Objectives",
    inclusionExclusionCriteria: "Eligibility criteria",
    consentDataResourceScopes: "Types of patient data needed",
    consentDataSensitivityScopes: "Sensitivity of patient data needed",
    targetNumberOfPatients: "Target number of patients",
    startDate: "Start date",
    completionDate: "Completion date",
    primaryCompletionDate: "Primary completion date",
    healthRecordsUpdatesEnabled: "Health records updates enabled",
    healthRecordsUpdatesOnDemand: "Health records updates on demand",
    healthRecordsUpdatesEvery: "Health records updates frequency",
    healthRecordsUpdatesUnit: "Health records updates frequency unit",
    sponsorOrganizationName: "Sponsor organization name",
    sponsorPrimaryContactName: "Contact name",
    sponsorPrimaryContactTitle: "Title",
    sponsorPrimaryContactEmail: "Email",
    sponsorPrimaryContactPhone: "Phone number",
    sponsorPrimaryContactPhoneExt: "Extension",
    funderType: "Funder type",
    studyIdentifier: "NCT ID",
    webpageLink: "Study website link",
    protocolNumber: "Protocol number",
    defaultRequire21CFRPart11ForInformedConsents: "21 CFR Part 11 compliance",
    isPrescreenConsentRequired: "Prescreen consent requirement",
    studyProtocolFileName: "Study protocol file name",
    icfImportMethod: "Option to build informed consent",
    icfFileName: "Informed consent file name",
    icfTextSegments: "Informed consent review items",
    studySectionImages: "Images",
    lastSkippedGenaiInputHash: "-",
    patientFriendlyTitle: "Patient-friendly title",
    patientFriendlySummary: "Patient-friendly summary",
    purposeOfResearchText: "Purpose of research",
    benefitsOfEnrollment: "Benefits",
    risksOfEnrollment: "Risks",
    proceduresAndInterventionsText: "Procedures and interventions",
    timelineVisitsEnabled: "Timeline for visits and interventions",
    timelineVisits: "Timeline for visits and interventions",
    alternativeProceduresAndTreatments: "Alternative procedures",
    injuryProtocolText: "Injury protocols",
    leavingStudyEarlyEnabled: "Withdrawal implications",
    leavingStudyEarlyText: "Withdrawal implications",
    participationTerminationEnabled: "Participation termination",
    participationTerminationText: "Participation termination",
    futureUseOfDataEnabled: "Future use of data",
    futureUseOfData: "Future use of data",
    futureUseOfDataText: "Future use of data",
    confidentialityOfDataText: "Confidentiality measures",
    compensation: "Compensation",
    compensationText: "Compensation",
    costOfParticipationEnabled: "Cost of participation",
    costOfParticipationText: "Cost of participation",
    sharingResultsEnabled: "Research results",
    sharingResultsText: "Research results",
    sitePrimaryContactName: "Name",
    sitePrimaryContactTitle: "Title",
    sitePrimaryContactEmail: "Email",
    sitePrimaryContactPhone: "Phone number",
    sitePrimaryContactPhoneExt: "Extension",
    additionalSections: "Additional information section",
    hipaaAuthorizationForm: "HIPAA authorization",
    hipaaAuthorizationTemplateEnabled: "HIPAA authorization",
    hipaaAuthorizationText: "HIPAA authorization",
    patientMRNOnInformedConsent: "Patient MRN",
    orgLogoOnInformedConsent: "Organization logo",
    enrollmentVideo: "Enrollment introduction video",
    deletePrescreenTranscode: "-",
    deleteEnrollmentTranscode: "-",
    investigationType: "Investigational Type",
    purposeOfResearchEnabled: "Purpose of research",
    informedConsentPrimaryDiseaseOrConditions: "Informed consent disease(s) or condition(s) being studied",
    informedConsentIRBApprovalStamp: "Informed consent IRB ApprovalStamp",
    informedConsentStartDate: "Informed consent start date",
    informedConsentCompletionDate: "Informed consent completion date",
    informedTargetNumberOfPatients: "Informed consent target number of patients",
    alternativesToParticipation: "Alternatives to participation",
    informedConsentInterested: "Needs follow-up",
    loginTitle: "Login section title",
    loginText: "Login message",
    welcomeTitle: "Enrollment section title",
    welcomeText: "Enrollment welcome message",
    dataUpdateWelcomeTitle: "Data update welcome section title",
    dataUpdateWelcomeText: "Data update welcome message",
    californiaBillOfRightsTitle: "California Patient Bill of Rights section title",
    californiaBillOfRightsText: "California Patient Bill of Rights",
    studyInformationTitle: "Study information section title",
    purposeOfResearchTitle: "Purpose of research section title",
    lengthOfStudyNumberOfParticipantsTitle: "Study length and number of participants section title",
    lengthOfStudyNumberOfParticipantsText: "Study length and number of participants description",
    proceduresAndInterventionsTitle: "Procedures and interventions section title",
    timelineTitle: "Timeline for visits and interventions section title",
    benefitsTitle: "Study benefits section title",
    risksTitle: "Study risks section title",
    voluntaryParticipationTitle: "Voluntary participation and alternatives section title",
    voluntaryParticipationText: "Voluntary participation statement",
    withdrawalImplicationsTitle: "Withdrawal implications section title",
    injuryProtocolTitle: "Injury protocol section title",
    participationTerminationTitle: "Participation termination section title",
    dataTypesTitle: "Data types section title",
    sensitiveDataTitle: "Sensitive data confirmation section title",
    sensitiveDataText: "Sensitive data statement",
    futureUseOfDataTitle: "Future use of data section title",
    confidentialityMeasuresTitle: "Confidentiality measures section title",
    compensationTitle: "Patient compensation section title",
    costTitle: "Cost of participation section title",
    researchResultsTitle: "Research results section title",
    whoToContactTitle: "Who to contact section title",
    whoToContactText: "Who to contact description",
    informedConsentTitle: "Enrollment informed consent decision section title",
    informedConsentText: "Enrollment informed consent introduction",
    informedConsentYesText: "Consent decision enroll text",
    informedConsentNoText: "Consent decision decline text",
    informedConsentInterestedText: "Consent decision needs follow-up text",
    hipaaTitle: "HIPAA authorization and consent statement section title",
    hipaaText: "HIPAA authorization introduction",
    hipaaOrganizationLegalName: "HIPAA authorization organization legal name",
    hipaaOrganizationLegalNameConfirmed: "HIPAA authorization organization legal name confirmation",
    thankYouConsentedTitle: "Enrollment consent confirmation section title",
    thankYouConsentedText: "Message to confirm consent to enrollment",
    dataUpdateThankYouConsentedTitle: "Confirmed data update section title",
    dataUpdateThankYouConsentedText: "Message to confirm data update",
    thankYouDeclinedTitle: "Decline enrollment confirmation section title",
    thankYouDeclinedText: "Message to confirm declining enrollment",
    thankYouImInterestedTitle: "Needs follow-up confirmation section title",
    thankYouImInterestedText: "Message to confirm needing follow-up",
    informedConsentPrimaryDiseaseOrConditionsCopied: "Informed consent disease(s) or condition(s) being studied copied",
    informedConsentStartDateCopied: "Informed consent start date copied",
    informedConsentCompletionDateCopied: "Informed consent completion date copied",
    informedTargetNumberOfPatientsCopied: "Informed consent target number of patients copied",
    lengthOfStudyEnabled: "Study length and number of participants included",
    informedHealthRecordUpdatesEnabled: "Patient health record updates included",
    healthRecordUpdatesTitle: "Patient health record updates section title",
    healthRecordUpdatesText: "Patient health record updates description",
    injuryProtocolEnabled: "Injury protocol included",
    interventionsEnabled: "Procedures and interventions included",
    confidentialityMeasuresEnabled: "Confidentiality measures included",
    patientMRNOnParticipantSignature: "Patient MRN on participant signature",
    minorParticipantConsentEnabled: "Minor Consent Supported",
    additionalParentGuardianEnabled: "Parent Guardian Consent Supported",
    additionalParentGuardianExemptSignature: "Additional Parent/Guardian Exemption Supported",
    minorParticipantExemptFromAssent: "Minor Assent Exemption Supported",
    larConsentEnabled: "LAR Consent Supported",
    larParticipantConsentExemptFromAssent: "Participant with LAR Assent Exemption Supported",
    parentGuardianTitle: "Parent/Guardian Title",
    parentGuardianInstructions: "Parent/Guardian Text",
    parentGuardianSignatureTitle: "Parent/Guardian Signature Title",
    parentGuardianInformedConsentStatement: "Parent/Guardian Informed Consent Statement",
    additionalParentGuardianTitle: "Additional Parent/Guardian Title",
    additionalParentGuardianInstructions: "Additional Parent/Guardian Text",
    additionalParentGuardianExemptSignatureText: "Additional Parent/Guardian ExemptionText",
    additionalParentGuardianSignatureTitle: "Additional Parent/Guardian Signature Title",
    additionalParentGuardianInformedConsentStatement: "Additional Parent/Guardian Informed Consent Statement",
    minorParticipantTitle: "Minor Participant Title",
    minorParticipantInstructions: "Minor Participant Text",
    minorParticipantExemptFromAssentText: "Minor Assent Exemption Text",
    minorParticipantAssentTitle: "Minor Assent Title",
    minorParticipantAssentStatement: "Minor Assent Text",
    participantTitle: "Participant Title",
    informedConsentStatement: "Participant Informed Consent Statement",
    participantInstructionsForGuidedConsent: "Participant Instructions for Guided Consent",
    larTitle: "LAR Title",
    larInstructions: "LAR text",
    larSignatureTitle: "LAR Signature Title",
    larInformedConsentStatement: "LAR Informed Consent Statement",
    larParticipantTitle: "Participant with LAR Title",
    larParticipantInstructions: "Participant with LAR Text",
    larParticipantExemptFromAssentText: "Participant with LAR Assent Exemption Text",
    larParticipantAssentTitle: "Participant with LAR Assent Title",
    larParticipantAssentStatement: "Participant with LAR Assent Text",
    witnessTitle: "Witness Title",
    witnessInstructions: "Witness Text",
    witnessSignatureTitle: "Witness Signature Title",
    witnessConfirmation: "Witness Confirmation Text",
    providerTitle: "Provider Title",
    providerInstructions: "Provider Text",
    providerSignatureTitle: "Provider Signature Title",
    providerConfirmation: "Provider Confirmation Text",
    studyTranslatableFields: "Study translatable fields",
    compositeUpdatedAt: "Composite updated at",
    importType: "Import type",
    enabled: "Enabled",
    suppressNotifications: "Suppress notifications",
    introTitle: "Intro title",
    introPurposeOfDisclosure: "Intro purpose of disclosure",
    introBriefEducation: "Intro brief education",
    patientHealthRecordRightsTitle: "Patient health record rights title",
    contactDetails: "Contact details",
    purposeOfDataTitle: "Purpose of data title",
    purposeOfDataDisclosure: "Purpose of disclosure",
    purposeOfDataDisclosureOther: "Other purpose of disclosure",
    purposeOfDataBriefEducation: "Introduction and brief education",
    organizationIconUrl: "Organization icon",
};
